import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useCallback, useMemo } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Tab, Tabs } from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import { DayScheduleElement } from './day';
import { days } from 'z3k-config';
const PREFIX = 'WeekScheduleEditor';
const classes = {
    interval_tab: `${PREFIX}-interval_tab`,
};
// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
    [`& .${classes.interval_tab}`]: {
        '& [class*="MuiTab"]': {
            minWidth: 30,
            justifyContent: 'space-between',
        },
    },
}));
export const WeekScheduleEditor = memo(function WeekScheduleEditor(props) {
    const { schedule, selected_day_id, selectDay, heating_modes, onChangeDays, selected_hc, is_boiler_zone, is_baxi_app, } = props;
    const tabs = useMemo(() => days.map((day) => _jsx(Tab, { label: day.name }, day.id)), [days]);
    const onChangeTab = useCallback((e, newIndex) => selectDay(newIndex), [selectDay]);
    const onChangeSingleDay = useCallback((day) => {
        onChangeDays([day]);
    }, [onChangeDays]);
    const controls = useMemo(() => schedule.week.map((day) => (_jsx(DayScheduleElement, { day: day, is_baxi_app: is_baxi_app, heating_modes: heating_modes, temp_or_mode: schedule.temp_or_mode, onChangeSingleDay: onChangeSingleDay, onChangeDays: onChangeDays, selected_hc: selected_hc, is_boiler_zone: is_boiler_zone }, day.key))), [schedule, heating_modes, selected_hc, onChangeSingleDay]);
    return (_jsxs(Root, { children: [_jsx(Box, { children: _jsx(Tabs, { className: classes.interval_tab, value: selected_day_id, onChange: onChangeTab, indicatorColor: "primary", textColor: "primary", variant: "scrollable", scrollButtons: "auto", selectionFollowsFocus: true, children: tabs }) }), _jsx(SwipeableViews, { index: selected_day_id ?? 0, onChangeIndex: selectDay, style: {
                    display: 'flex',
                    flexGrow: 1,
                    flexDirection: 'column',
                }, containerStyle: {
                    flexGrow: 1,
                    height: '100%',
                }, children: controls })] }));
});
